import { useEffect, useState, useCallback } from "react";
import { fetchCategoriesAndTypes } from "../../Services/Realtionship";

/**
 * Shared hook to fetch and manage relationship options (categories, types, statuses).
 *
 * @param {Object} params
 * @param {string} [params.initialCategory]
 */
export default function useRelationshipOptions({ initialCategory } = {}) {
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadCategories = useCallback(async () => {
    try {
      const categoriesData = await fetchCategoriesAndTypes();
      setCategories(Array.isArray(categoriesData) ? categoriesData : []);
    } catch (e) {
      setError(e);
    }
  }, []);

  const loadStatuses = useCallback(async () => {
    try {
      const statusesData = await fetchCategoriesAndTypes("status");
      setStatuses(Array.isArray(statusesData) ? statusesData : []);
    } catch (e) {
      setError(e);
    }
  }, []);

  const loadTypes = useCallback(async (category) => {
    if (!category) {
      setTypes([]);
      return [];
    }
    try {
      const resp = await fetchCategoriesAndTypes(category);
      const next = Array.isArray(resp) ? resp : [];
      setTypes(next);
      return next;
    } catch (e) {
      setError(e);
      setTypes([]);
      return [];
    }
  }, []);

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      await Promise.all([loadCategories(), loadStatuses()]);
      if (initialCategory) {
        await loadTypes(initialCategory);
      }
      if (mounted) setLoading(false);
    })();
    return () => {
      mounted = false;
    };
  }, [initialCategory, loadCategories, loadStatuses, loadTypes]);

  return {
    categories,
    types,
    statuses,
    loadTypes,
    loading,
    error,
  };
}
